<template>
    <v-container>
        <v-card>
            <v-card-title>{{localItem.title}}
                <v-card v-if="type=='cases'"
                color="#385F73"
                dark
                class="d-inline-block mx-auto"
                >
                <v-card-subtitle class="pa-1">Case</v-card-subtitle>
                </v-card>
                <v-card v-if="type=='treatments'"
                color="#C1BBA2"
                dark
                class="d-inline-block mx-auto"
                >
                <v-card-subtitle class="pa-1">Treatment</v-card-subtitle>
                </v-card>
            </v-card-title>
            <v-card-subtitle @click="viewUserProfile(localItem.owner)">By: {{localItem.ownerName}}</v-card-subtitle>
            <!-- Show date/last modified -->
            <v-card-text>{{localItem.description}}</v-card-text>
            <v-carousel
            cycle
            height="400"
            hide-delimiter-background
            show-arrows-on-hover
            >
                <v-carousel-item
                    v-for="(image, i) in getPreviewImages"
                    :key="i"
                >
                    <v-row
                        class="fill-height"
                        align="center"
                        justify="center"
                    >
                        <v-img
                        aspect-ratio="1"
                        height="200"
                        max-width="200"
                        :src="image"
                        :lazy-src="require('./../../../assets/ViewTreatmentScreen/imageIcon.png')"                                    
                        >
                            <template v-slot:placeholder>
                                <v-row
                                    class="fill-height ma-0"
                                    align="center"
                                    justify="center"
                                >
                                    <v-progress-circular indeterminate color="primary"></v-progress-circular>
                                </v-row>
                            </template>
                        </v-img>
                    </v-row>
                </v-carousel-item>  
            </v-carousel>

            <v-card-actions>
                    <!-- Comment Icon, with number of comments (can be a link?) Vote Control far right -->
                    <v-btn @click="viewFullItem()" text color="primary">Read More</v-btn> 
                    <v-spacer></v-spacer>
                    <v-btn @click="viewFullItem()" icon>
                        <span v-if="localItem.comments"> {{localItem.comments.length}}</span>   
                        <span v-else>0</span>
                        <v-icon>mdi-forum</v-icon>
                    </v-btn>
                    <v-btn v-if="type=='cases'" icon>
                        {{localItem.upvotes}}
                        <v-icon>mdi-plus</v-icon>
                    </v-btn>
                    <span v-if="type=='treatments'">
                    <vote-control :parentItem="{id: localItemId, data: localItem}" :commentMode="false" :commentItem="null"></vote-control>
                    </span>
            </v-card-actions>
        </v-card>

        <!-- VIEW TREATMENT DIALOG -->
        <v-dialog v-model="viewTreatmentDialog" :retain-focus="false" fullscreen hide-overlay persistent transition="dialog-bottom-transition">
            <view-treatment-screen-popup 
            v-if="viewTreatmentDialog"
            v-on:dialogClosed="closeViewTreatment()"
            :treatment="currentShownItem.data"
            :treatmentId="currentShownItem.id"
            :uid="uid"
            :showToolbar="true">
            </view-treatment-screen-popup>
        </v-dialog>

        <!-- VIEW CASE DIALOG -->
        <v-dialog v-model="viewCaseDialog" :retain-focus="false" fullscreen hide-overlay persistent transition="dialog-bottom-transition">
            <view-case-screen-popup 
            v-if="viewCaseDialog"
            v-on:dialogClosed="closeViewCase()"
            :case="currentShownItem.data"
            :caseId="currentShownItem.id"
            :uid="uid"
            :showToolbar="true">
            </view-case-screen-popup>
        </v-dialog>

        <!-- VIEW PROFILE DIALOG -->
        <v-dialog v-model="viewProfileDialog" :retain-focus="false" fullscreen hide-overlay transition="dialog-bottom-transition">              
            <profile-screen
            v-if="viewProfileDialog"
            v-on:dialogClosed="closeViewProfile()"
            :user="currentViewedUser"
            :label="currentViewedUser.displayname"
            :myProfile="false">
            </profile-screen>
        </v-dialog>
    </v-container>
</template>

<script>
import TreatmentDataService from './../../../services/treatmentDataService.js';
import UserDataService from '../../../services/userDataService';
import VoteControl from './../Voting/VoteControl.vue';
import ViewTreatmentScreenPopup from './../Popups/ViewTreatmentScreenPopup.vue';
import ViewCaseScreenPopup from './../../Cases/Popups/ViewCaseScreenPopup.vue';
import ProfileScreen from './../../Management/ProfileScreen.vue';
import Toast from './../../../plugins/customToast.js';

export default {
    name: 'quickView',
    components: {
        VoteControl,
        ViewTreatmentScreenPopup,
        ViewCaseScreenPopup,
        ProfileScreen
    },
    props: {
        item: Object,
        itemId: String,
        type: String
    },
    beforeCreate(){
        this.$options.components.ProfileScreen = require('./../../Management/ProfileScreen.vue').default
        this.$options.components.ViewTreatmentScreenPopup = require('./../Popups/ViewTreatmentScreenPopup.vue').default
        this.$options.components.ViewCaseScreenPopup = require('./../../Cases/Popups/ViewCaseScreenPopup.vue').default
    },
    mounted(){
        if (this.item){
            this.localItem = this.item;
            this.localItemId = this.itemId;
        }
        
        this.treatmentService = new TreatmentDataService(this.$route.params.userDb);
        this.userDataService = new UserDataService();

        this.uid = this.$route.params.userDb.uid;
    },
    methods: {
        viewFullItem(){
            if (this.type=="treatments"){
                this.viewTreatment();
            } else {
                this.viewCase();
            }
        },
        viewCase() {
            if (this.localItemId != null){
                this.currentShownItem = { id: this.localItemId, data: this.localItem };
                console.log("Viewing Case Item: " + this.localItem.title + " by " + this.localItem.ownerName) // eslint-disable-line no-console
                this.viewCaseDialog = true;
            }
        },
        viewTreatment() {
            if (this.localItemId != null){
                this.currentShownItem = { id: this.localItemId, data: this.localItem };
                console.log("Viewing Treatment Item: " + this.localItem.title + " by " + this.localItem.ownerName) // eslint-disable-line no-console
                this.viewTreatmentDialog = true;
            }
        },
        async viewUserProfile(profileId){
            var that = this;
            this.userDataService.searchFirebaseByUserId(profileId)
            .then(function (result) {
                if (result !== null){
                    //If call was successful for user, show their profile page
                    console.log("viewing user profile: " + result); //eslint-disable-line
                    that.currentViewedUser = result;
                    that.viewProfileDialog = true;
                } else {
                    Toast.fire({  icon: 'error',  title: `Cannot currently view user profile`});
                }            
            }).catch(function (error) {
                Toast.fire({  icon: 'error',  title: `Cannot currently view user profile: ${error}`});
            });        
        },
        closeViewProfile(){
            this.currentViewedUser = {};
            this.viewProfileDialog = false;
        },
        closeViewTreatment() {            
            this.viewTreatmentDialog = false;
            this.currentShownItem = {};
        },
        closeViewCase() {
            this.viewCaseDialog = false;
            this.currentShownItem = {};
        }
    },
    watch: {
        item: function() {
            if (this.item){
                this.localItem = this.item;
                this.localItemId = this.itemId;
            }
        }
    },
    computed: {
        getPreviewImages(){
            if (this.type === "treatments"){
                return this.localItem.images;
            } else {
                if (this.localItem.treatments){
                    return this.localItem.treatments.map(t => t.previewImage);
                } else {
                    return [];
                }                
            }
        }
    },
    data: () => ({
      treatmentImages: [],
      currentShownItem: {},
      localItem: {},
      localItemId: "",
      treatmentService: {},
      currentViewedUser: {},
      viewProfileDialog: false,
      viewTreatmentDialog: false,
      viewCaseDialog: false,
      uid: ""
    })    
}
</script>